import NextLink from 'next/link';

import { selectCurrentUser } from 'features/auth/slice';
import { useSelector } from 'react-redux';

import { Card, Heading, Icon } from '@frontendmentorio/design-system-v2';

function ListItem({ children, isIncluded }) {
  return (
    <li className="flex gap-2 items-center">
      <Icon
        className={isIncluded ? 'text-emerald-400' : 'text-rose-600'}
        name={isIncluded ? 'check' : 'xmark'}
        style="solid"
      />
      {children}
    </li>
  );
}

export default function Assets({ challenge }) {
  const currentUser = useSelector(selectCurrentUser);

  return (
    <Card className="flex flex-col gap-4 p-5">
      <Heading className="flex gap-2" level="4" tagName="h2">
        <span>🗃</span>
        Assets provided
      </Heading>

      <ul className="flex flex-col gap-2">
        {challenge.type === 'free' ? (
          <>
            <ListItem isIncluded={currentUser?.hasActiveSubscription}>
              Figma design file access{' '}
              {currentUser?.hasActiveSubscription ? (
                <>(included with Pro)</>
              ) : (
                <>
                  -{' '}
                  <NextLink
                    className="font-semibold underline hover:no-underline"
                    href="/pro"
                  >
                    Unlock with Pro
                  </NextLink>
                </>
              )}
            </ListItem>

            <ListItem isIncluded>
              JPEG design files for mobile & desktop layouts
            </ListItem>

            <ListItem isIncluded>Style guide for fonts, colors, etc.</ListItem>
          </>
        ) : (
          <>
            <ListItem isIncluded>
              Figma design files{' '}
              {challenge.type === 'free-plus' && (
                <>(included with Free+ challenges)</>
              )}
            </ListItem>

            <ListItem isIncluded>Mobile, tablet &amp; desktop layouts</ListItem>

            <ListItem isIncluded>
              Professional design system for colors, fonts, etc.
            </ListItem>
          </>
        )}
        <ListItem isIncluded>Optimized image assets</ListItem>

        <ListItem isIncluded>README file to help you get started</ListItem>

        <ListItem isIncluded>HTML file with pre-written content</ListItem>
      </ul>
    </Card>
  );
}
